import React, { useEffect, useState, useRef } from 'react';
import { Globe } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage, languages } from '../../hooks/useLanguage';
export function LanguageToggle() {
  const {
    language,
    setLanguage
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const currentLanguage = languages.find(l => l.code === language);
  return <div className="relative" ref={dropdownRef} data-id="element-205">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors" aria-label="Select language" data-id="element-206">
        <Globe className="w-4 h-4 text-gray-600" data-id="element-207" />
        <span className="text-sm font-medium text-gray-700" data-id="element-208">
          {currentLanguage?.flag}
        </span>
      </button>

      <AnimatePresence data-id="element-209">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.2
      }} className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg border border-gray-200 py-2 z-50" data-id="element-210">
            {languages.map(lang => <button key={lang.code} onClick={() => {
          setLanguage(lang.code);
          setIsOpen(false);
        }} className={`w-full flex items-center gap-3 px-4 py-2.5 text-left transition-colors ${language === lang.code ? 'bg-blue-500/10 text-blue-600 font-semibold' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-211">
                <span className="text-xl" data-id="element-212">{lang.flag}</span>
                <span className="text-sm" data-id="element-213">{lang.label}</span>
              </button>)}
          </motion.div>}
      </AnimatePresence>
    </div>;
}